import Head from 'next/head'
import React from 'react'
import { useTranslation } from 'hooks/useTranslation'
import { HomeAlternate } from 'features/Home/screens/HomeAlternate'

export default function HomePage() {
  const { t } = useTranslation()

  return (
    <div>
      <Head>
        <title>{t('home:meta-title')}</title>
        <meta name="title" content={t('home:meta-title')} />
        <meta name="description" content={t('home:meta-description')} />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <HomeAlternate />
    </div>
  )
}
